import { rem, Stack } from "@mantine/core";

export const PageContainer = Stack.withProps({
  pt: rem(78),
  px: rem(48),
  pb: rem(48),
});
